{
  "Earlier": "PLUS TÔT",
  "newNotification": "{newCount} nouvelle notification",
  "newNotifications": "{newCount} nouvelles notifications",
  "noNotifications": "Vous recevrez des informations importantes sur nos produits, votre collaboration avec d’autres utilisateurs et d’autres mises à jour pertinentes",
  "noNotificationsTitle": "Vos notifications apparaîtront ici"
}
